import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App";
import router from "./routes/initRouter";
import vuetify from "./plugins/vuetify";
import money from "v-money";
import Axios from "./plugins/axios";
import VeeValidate from "./plugins/vee-validate";

Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.use(money, { precision: 0 });
Vue.use(VueRouter);
Vue.use(Axios);

new Vue({
  render: h => h(App),
  vuetify,
  router
}).$mount("#app");
